module.exports = __webpack_public_path__ + "assets/CTA1.dac5738f.png";